// File: src/components/FloatingContactButtons.jsx
import React, { useState, useEffect } from "react";
import { FaWhatsapp, FaPhone, FaTimes } from "react-icons/fa";
import "../Styles/FloatingContactButtons.css";
import ChatBotIcon from "./ChatBot";

const FloatingContactButtons = () => {
  const [showButtons, setShowButtons] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // Optional: Show buttons after scrolling
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowButtons(true);
      } else {
        setShowButtons(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // WhatsApp number - replace with your actual number
  const whatsappNumber = "+971502576257"; // Your WhatsApp number
  const phoneNumber = "+971502576257"; // Your phone number

  // Pre-filled message (optional)
  const whatsappMessage = "Hello, I need assistance with your products.";

  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${whatsappNumber.replace(/\+/g, "")}?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(url, "_blank");
  };

  const handleCallClick = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <div className="floating-contact-container">
      {/* Main toggle button - uncomment if you want toggle functionality */}
      {/* <button 
        className="floating-toggle-btn"
        onClick={() => setShowTooltip(!showTooltip)}
      >
        {showTooltip ? <FaTimes /> : <FaWhatsapp />}
      </button> */}
      <ChatBotIcon />

      {/* Buttons container - always visible or conditionally visible */}
      <div className={`floating-buttons ${showButtons ? "visible" : ""}`}>
        {/* Call Button */}

        {/* WhatsApp Button */}
        <div className="floating-button-wrapper">
          <button
            className="floating-btn whatsapp-btn"
            onClick={handleWhatsAppClick}
            aria-label="WhatsApp us"
          >
            <FaWhatsapp />
          </button>
          <span className="tooltip">WhatsApp us</span>
        </div>
        <div className="floating-button-wrapper">
          <button
            className="floating-btn call-btn"
            onClick={handleCallClick}
            aria-label="Call us"
          >
            <FaPhone />
          </button>
          <span className="tooltip">Call us</span>
        </div>
      </div>
    </div>
  );
};

export default FloatingContactButtons;
